import { Box, Menu, MenuItem } from "@mui/material";
import Add from "@mui/icons-material/Add";
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import { useState } from "react";
import { TinyButton } from "../../misc/TinyButton";

// NewTaskButton opens a new task, and its arrow offers the other ways to add tasks
export function NewTaskButton(props: { onTask: () => void; onChain: () => void }) {
    const [anchor, setAnchor] = useState<HTMLElement | null>(null);

    return (
        // both halves take the height of the taller one, so they read as one button
        <Box sx={{ display: "inline-flex", alignItems: "stretch" }}>
            <TinyButton variant="outlined" color="primary"
                        startIcon={<Add sx={{ fontSize: 16 }} />}
                        sx={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
                        onClick={props.onTask}>
                New task
            </TinyButton>
            <TinyButton variant="outlined" color="primary" aria-label="More ways to add tasks"
                        aria-haspopup="menu"
                        // as the icon rather than the label, the arrow is centred in the
                        // button instead of sitting on the text's baseline
                        startIcon={<ArrowDropDown sx={{ fontSize: 16, display: "block" }} />}
                        sx={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, borderLeft: 0, px: 0 }}
                        onClick={e => setAnchor(e.currentTarget)} />

            <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
                <MenuItem onClick={() => {
                    setAnchor(null);
                    props.onChain();
                }}>
                    New task chain
                </MenuItem>
            </Menu>
        </Box>
    );
}
